<template>
  <div class="afecha-wrap" :class="{'afecha-error': validation.hasError('mirror')}">
    <datepicker
      ref="programaticOpen"
      :format="format"
      :value="modelo.fecha"
      @input="fechaSelect"
      :typeable="true"
      :clear-button="true"
      :language="espanol"
      placeholder="DD/MM/YYYY">
    </datepicker>
    <div class="afecha-err-msg" v-if="validation.hasError('mirror')">
      {{ validation.firstError('mirror') }}
    </div>
  </div>
</template>

<style>
.afecha-wrap .vdp-datepicker {
  width: 100%;
}
.afecha-wrap .vdp-datepicker__calendar {
  z-index: 200;
}
.afecha-wrap input {
  width: 100% !important;
  height: 36px;
  border: 1px solid rgba(0, 0, 0, 0.38) !important;
  border-radius: 4px !important;
  padding: 0 10px !important;
  font-size: 13px !important;
  box-shadow: none !important;
  outline: none !important;
  background: #ffffff !important;
  color: rgba(0, 0, 0, 0.87) !important;
  transition: border-color 0.2s;
  cursor: pointer;
  box-sizing: border-box;
}
.afecha-wrap input:hover {
  border-color: rgba(0, 0, 0, 0.87) !important;
}
.afecha-wrap input:focus {
  border-color: #1565c0 !important;
  border-width: 2px !important;
  outline: none !important;
}
.afecha-error input {
  border-color: #f44336 !important;
}
.afecha-err-msg {
  font-size: 12px;
  color: #f44336;
  margin-top: 2px;
}
</style>

<script>
//import Datepicker from 'vuejs-datepicker'
import Datepicker from '@hokify/vuejs-datepicker';
import { Validator } from 'simple-vue-validator';
import "@hokify/vuejs-datepicker/dist/vuejs-datepicker.css"; // include CSS
//import {mask} from 'vue-the-mask'
export default {
    props:{ 
        model:Object,valueto:{type:String,required:false,default:null },
        default:{type:String,required:false,default:null},
        datenewrest:{type:Boolean,required:false,default:false}, // para indicar que la fecha es en formato: dd/mm/yyyy
    },
    data(){
        return{
            espanol: 'es',
            format: "DD/MM/YYYY",
            mirror: null, // permite validar la fecha, pero no es la que se usa
            datos: [],
            modelo: {
                fecha: null,
            }
        }
    },
    //directives: {mask}, // default uncoment
    components:{Datepicker},
    watch:{
       /* 'modelo.fecha': function(a){
            if(a==null) return;
            var partes = a.split("/");
            var fec = partes[2]+"-"+partes[1]+"-"+partes[0];
            window.console.log( "FECHA::: ",fec )
            if( this.valueto != null ) this.model[this.valueto] = fec;
            else this.model.fecha = fec;
        },*/
        'default': function(){
            //window.console.log( "DEFAULTTTTT ",this.default );
            this.parseDefault();
        },
    },
    validators: {
        'modelo.fecha'(value){
            return Validator.value(value).regex('^[0-9]{2}/[0-9]{2}/[0-9]{4}$');
        },
        'mirror'(value){
            if( this.datenewrest ) return Validator.value(value).regex('^[0-9]{2}/[0-9]{2}/[0-9]{4}$');
            else return Validator.value(value).regex('^[0-9]{4}-[0-9]{2}-[0-9]{2}$'); // al server anio-mes-dia
        }
    },
    methods:{
        openPicker() {
            this.$refs.programaticOpen.showCalendar();
        },
        customFormatter(date) {
            return this.$moment(date).format('dd/MM/yyyy');
        },
        fechaSelect(dat){
            var date = dat;
            if( !date ) return;
            var d = date.getDate();
            var m = date.getMonth()+1;
            var a = date.getFullYear();
            // window.console.log('fechaaaa', a);
            // if(a <= 1900) return;
            if( d < 10 ) d = '0'+d;
            if( m < 10 ) m = '0'+m;
            var fec = a+"-"+m+"-"+d;
            if( this.datenewrest ){
                fec = d+"/"+m+"/"+a;
            }
            // window.console.log( "fechaSelect ",fec );
            if( this.valueto ) this.model[this.valueto] = fec;
            else this.model.fecha = fec;
            this.mirror = fec; // para mostrar la fecha 
        },
        parseDefault(){
            //window.console.log( "XPRINT DEFAULT: >> ",this.default )
            if( this.default ) {
                //window.console.log( "PRINT DEFAULT: ",this.default )
                var ps = this.default.split("-");
                var def = ps[1]+"/"+ps[2]+"/"+ps[0];
                this.modelo.fecha = def;
                var fec = ps[0]+"-"+ps[1]+"-"+ps[2];
                if( this.datenewrest ){
                    fec = ps[2]+"/"+ps[1]+"/"+ps[0];
                }

                if( this.valueto ) this.model[this.valueto] = fec;
                else this.model.fecha = fec;
                //window.console.log( "XPRINT DEFAULT: >> ",def )
                //window.console.log( "DEFAULT FECHA: "+def )
            }
        },

        findFn(fec){
            window.console.log('-------------', fec);
            this.modelo.fecha = fec;
        }
    },
    mounted(){
        //this.modelo.fecha = new Date(2016, 9,  16);
        this.$validate().then(() => {  });        
        this.parseDefault();
    }
}
</script>